// File: cgp-notification-menu.module.ts
// Author: Brandon Shreve
// Date: 10/25/2018
// Desc: Menu to display notifications
// Other Contributors:

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CgpNotificationMenuComponent } from './cgp-notification-menu.component';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatMenuModule,
        MatTooltipModule
    ],
    exports: [
        CgpNotificationMenuComponent
    ],
    declarations: [
        CgpNotificationMenuComponent
    ],
    providers: []
})
export class CgpNotificationMenuModule { }
